import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { MEDIUM_LIVED_CACHE } from "@/lib/constants/cache";
import type { UserPermissions, UUID } from "@/core/types";

import { getUserPermissions } from "../queryFunctions/getUserPermissions";
import { permissionsKeys } from "../keyFactory";

type UseUserPermissionsProps<TData = UserPermissions> = {
  enabled?: boolean;
  select?: (data: UserPermissions) => TData;
  userId: UUID;
};

type UserPermissionsQueryOptions = UseQueryOptions<
  UserPermissions,
  unknown,
  UserPermissions,
  ReturnType<typeof permissionsKeys.userPermissions>
>;

export function optionFactory(userId: UUID, enabled = true) {
  return {
    enabled,
    queryFn: () => getUserPermissions(userId),
    queryKey: permissionsKeys.userPermissions(userId),
    staleTime: MEDIUM_LIVED_CACHE,
  } satisfies UserPermissionsQueryOptions;
}

export function useUserPermissions<TData = UserPermissions>({
  enabled = true,
  select,
  userId,
}: UseUserPermissionsProps<TData>) {
  return useQuery({ ...optionFactory(userId, enabled), select });
}
